// Simple Payment Component - Credit Card via Creem checkout + Regional QR
import React from 'react';
import { Tab } from "@headlessui/react";
import CountryQRPayment from "./CountryQRPayment";
import { useLanguage } from '../contexts/LanguageContext';

const CREEM_CHECKOUT_URLS = {
  Basic: 'https://creem.io/payment/prod_5rtvWDDvtLx4U8bl5qeYFU',
  Pro: 'https://creem.io/payment/prod_5QxuLx7GPiFaJnsPzF80UF',
  Studio: 'https://creem.io/payment/prod_2VpFAdR0t75FG5ByjnQEu1',
};

export default function Payment({ planId, planName, amount, userEmail, onSuccess, onCancel }) {
  // Normalize plan names to match backend
const normalizedPlanName = planName.replace(" Plan", "");
// e.g. "Basic Plan" → "Basic", "Pro Plan" → "Pro"
const { t } = useLanguage();

const selectedPlan = {
  id: planId,
  name: normalizedPlanName,
  price: amount
};

  const handleCreditCardCheckout = () => {
    const checkoutUrl = CREEM_CHECKOUT_URLS[normalizedPlanName];
    if (!checkoutUrl) return;

    const url = userEmail
      ? `${checkoutUrl}?email=${encodeURIComponent(userEmail)}`
      : checkoutUrl;

    window.location.href = url;
  };

  const paymentMethods = [
    { name: "Credit Card" },
    { name: "Regional QR" }
  ];

  return (
    <div className="max-w-md mx-auto p-4">
      <h2 className="text-xl font-bold mb-4 text-center text-white">{t('choosePaymentMethod')}</h2>
      <div className="text-center mb-4">
        <p className="text-gray-400">{planName} - ${amount}/month</p>
      </div>

      <Tab.Group>
        <Tab.List className="grid grid-cols-2 gap-2 mb-4">
          {paymentMethods.map((method) => (
            <Tab
              key={method.name}
              className={({ selected }) =>
                `px-3 py-2 rounded-lg font-medium text-sm ${
                  selected
                    ? "bg-red-600 text-white"
                    : "bg-gray-700 text-gray-200 hover:bg-gray-600"
                }`
              }
            >
              {method.name}
            </Tab>
          ))}
        </Tab.List>

        <Tab.Panels>
          {/* Credit Card Panel - redirects straight to Creem checkout */}
          <Tab.Panel>
            <div className="bg-gray-800 rounded-lg p-6 text-center">
              <div className="text-4xl mb-3">💳</div>
              <h3 className="text-white font-semibold mb-2">Pay with Credit Card</h3>
              <p className="text-gray-400 text-sm mb-4">
                You'll be redirected to our secure checkout to complete your payment.
              </p>
              <button
                onClick={handleCreditCardCheckout}
                className="w-full bg-red-600 hover:bg-red-700 text-white font-semibold py-3 px-6 rounded-lg transition-colors"
              >
                Upgrade
              </button>
            </div>
          </Tab.Panel>

          {/* Regional QR Panel */}
          <Tab.Panel>
            <CountryQRPayment
  selectedPlan={selectedPlan}
  onBack={onCancel}
  onSuccess={onSuccess}
/>
          </Tab.Panel>
        </Tab.Panels>
      </Tab.Group>
    </div>
  );
}
